import React from 'react';
import AppIcon from '../../images/ic-dodo-app.svg';
import style from './index.module.scss';
import { useTranslation } from 'react-i18next';
import { isIOS } from 'react-device-detect';
import { androidAppDownloadUrls, iosAppDownloadUrls } from 'util/env';

type Props = {
  country: string;
};

export const AppBanner = ({ country }: Props) => {
  const { t } = useTranslation();

  const handleClick = () => {
    const urlTarget = isIOS ? iosAppDownloadUrls : androidAppDownloadUrls;
    const url = country === 'KR' ? urlTarget.kr : urlTarget.jp;
    window.open(url, '_system');
  };

  return (
    <header data-id="btn_app_banner" className={style.appBanner} onClick={handleClick}>
      <div className={style.appIcon}>
        <AppIcon />
      </div>
      <div className={style.content}>{t('앱에서 쿠폰까지 확인하세요')}</div>
      <div className={style.open}>{t('열기')}</div>
    </header>
  );
};
